import { InternalMessageBusChannels } from "sb-internal-msg-bus";
var MessageSender = /** @class */ (function () {
    function MessageSender(messageBus, channelPrefix) {
        this.messageBus = messageBus;
        this.channelPrefix = channelPrefix;
    }
    MessageSender.prototype.SendMessage = function (item) {
        var message = messageGenerator[item.type](item);
        var channel = this.channelPrefix + "." + InternalMessageBusChannels.eventsFilter[item.type];
        this.messageBus.emit(channel, message);
    };
    return MessageSender;
}());
export { MessageSender };
var messageGenerator = {
    sports: function (item) { return ({ sportIds: [item.id] }); },
    allSports: function (_) { return ({ sportIds: [] }); },
    favorites: function (_) { return ({}); },
    liveStream: function (_) { return ({}); },
    dates: function (item) { return ({
        dateRange: {
            from: item.from,
            timeRange: item.timeRange
        }
    }); }
};
//# sourceMappingURL=MessageSender.js.map